import { AffiliateApi } from "@/api/affiliates";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetAcquiredUsers = (page: number = 0, perPage: number = 5) => {
  const { data, isPending } = useQuery({
    queryKey: [QueryKey.ACQUIRED_USERS, page, perPage],
    queryFn: () => AffiliateApi.getAcquiredUsers(page + 1, perPage),
    staleTime: 180000,
  });

  return {
    acquiredUsers: data?.data,
    meta: data?.meta,
    isAcquiredUsersLoading: isPending,
  };
};
